import { View, RadioGroup, Button } from "@/components/ui";
import { useBookingState } from "@/store/booking/useBookingState";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { ListHeading } from "@/components/shared/list-header";
import { Cube } from "@/components/shared/icons";
import { ServiceRadioCard } from "../service-radio-card";
import { useEffect } from "react";
import { HomeMassageUnitTypeOptions } from "@/constants/booking";
import { formatPrice } from "@/lib/helpers/number";
import { showToast } from "@/components/ui/toast/show-toast";
import { useBookingRoute } from "@/components/hooks/use-booking-route";
import { Spin } from "@/components/shared/spin";
import { Typography } from "../../typography";
import { type PackageUnitTypeEnum } from "@/__generated__/graphql";

export const ChooseMassagePackageModal = () => {
  const { forward } = useBookingRoute();
  const {
    data: {
      packageDetailsFilter,
      choosePackageLoading,
      homeMassagePackageModalOpen,
    },
    setBookingState,
  } = useBookingState();

  useEffect(() => {
    if (homeMassagePackageModalOpen) {
      setBookingState({
        packageDetailsFilter: {
          ...packageDetailsFilter,
          unitTypes: [HomeMassageUnitTypeOptions[0].value],
        },
      });
    }
  }, [homeMassagePackageModalOpen]);

  const onSelect = (value: PackageUnitTypeEnum) => {
    setBookingState({
      packageDetailsFilter: {
        ...packageDetailsFilter,
        unitTypes: [value],
      },
    });
  };

  const onContinue = () => {
    if (!packageDetailsFilter?.unitTypes?.length) {
      return showToast({
        title: "Please choose your package!",
        type: "info",
      });
    }
    setBookingState({
      homeMassagePackageModalOpen: false,
    });
    forward();
  };

  return (
    <BottomDrawerModal
      open={homeMassagePackageModalOpen}
      onOpenChange={() => {
        setBookingState({
          homeMassagePackageModalOpen: false,
        });
      }}
    >
      <View className="flex flex-col gap-4">
        <ListHeading title="Select Service" icon={Cube} />
        <Typography variant="body-md" color="foreground-intermediate">
          Choose the service category that suits your needs best.
        </Typography>

        <View>
          {choosePackageLoading && <Spin className="my-12 size-12 shrink-0" />}
          <RadioGroup
            value={packageDetailsFilter.unitTypes?.[0]}
            onValueChange={() => {}}
          >
            {HomeMassageUnitTypeOptions.map((option) => {
              return (
                <ServiceRadioCard
                  key={option.value}
                  active={packageDetailsFilter.unitTypes?.[0] === option.value}
                  onSelect={() => onSelect(option.value)}
                  imgUrl={option.imgUrl}
                  title={option.title}
                  value={option.value}
                  subTitle={`Starting ${formatPrice(option.price)} /session`}
                  thirdTitle="60 mins · 90 mins · 120 mins"
                />
              );
            })}
          </RadioGroup>
        </View>

        <Button
          variant="primary"
          color="CTA"
          size="lg"
          rounded="full"
          onClick={onContinue}
          children="Continue"
        />
      </View>
    </BottomDrawerModal>
  );
};
